<script setup lang="ts">
import { useRoguelikeGameStore } from '@/stores/modules/miniGames'
import { QuestionFilled } from '@element-plus/icons-vue'
import { ref } from 'vue'
import RoguelikeRank from './RoguelikeRank.vue'

const roguelikeGameStore = useRoguelikeGameStore()
const dialogVisible = ref(false)

async function handleStart() {
  dialogVisible.value = true
}
function handleSelect(i: number) {
  dialogVisible.value = false
  roguelikeGameStore.startGame(i)
}
const roguelikeRankRef = ref<InstanceType<typeof RoguelikeRank>>()
function handleShowRank() {
  roguelikeRankRef.value?.open()
}
</script>
<template>
  <div class="border-wrap">
    <div class="left">
      <h4 style="display: flex; align-items: center; color: #c0c6c0">
        无尽之巅
        <div class="help-info" style="margin-left: 5px">
          <el-popover placement="top" width="100%" trigger="click">
            <template #reference>
              <el-icon size="20">
                <QuestionFilled />
              </el-icon>
            </template>
            <div class="affix">
              <h4>无尽之巅说明</h4>
              <p>
                1.
                在无尽之巅中，怪物会越来越强大，而你会不断流逝生命力，通过击杀怪物获取战利品来提升战斗力，在地狱模式中你只会遇到已在图鉴中点亮的装备。
              </p>
              <p>2. 因玩法需要，部分战斗机制和装备效果与常规模式有差异，具体以本模式内容为准。</p>
              <p>3. 本模式需<span class="hp">在线游玩，不支持离线战斗</span>，同时尽量避免切换后台。</p>
              <p>4. 完成一次<span class="grow">5分钟</span>以上的对局，游戏结算时会将您的分数上传至排行榜。</p>
              <p>5. 奖励规则 <span class="info">每周日3点发放</span>：</p>
              <p style="text-indent: 2em">
                a.
                <span class="grow">参与奖</span>：当您本周有分数上传，即完成一次<span class="grow">5分钟</span>以上的对局，每周可获得100,000金币。
              </p>
              <p>6. <b style="color: orange">该模式由【西瓜】友情开发，现已停止维护，如遇BUG无需反馈。</b></p>
            </div>
          </el-popover>
        </div>
      </h4>
      <div style="margin: 10px 0">
        <el-button @click="handleStart()" type="success" plain style="min-width: 120px"> 开始 </el-button>
        <el-button @click="handleShowRank()" type="primary" plain style="min-width: 120px"> 排行 </el-button>
      </div>
    </div>
    <el-dialog title="难度选择" v-model="dialogVisible" width="80%" style="max-width: 400px">
      <div class="affix" style="display: flex; gap: 16px; flex-direction: column; align-items: center">
        <div>
          <p>确定进入<span class="info">【无尽之巅】</span>吗？</p>
          <p class="grow">（该模式必须在线游玩）</p>
        </div>
        <el-button
          @click="handleSelect(i)"
          v-for="(item, i) of roguelikeGameStore.DEGREE_CONFIG"
          :type="item.btnType as never"
          plain
          class="degree-card"
          :key="item.name"
        >
          <div>{{ item.name }}</div>
          <p>{{ item.desc }}</p>
        </el-button>
      </div>
    </el-dialog>
    <RoguelikeRank ref="roguelikeRankRef" />
  </div>
</template>
<style lang="scss" scoped>
:deep(.degree-card) {
  width: 100%;
  height: 60px;
  margin: 0 !important;

  span {
    display: flex;
    flex-direction: column;
    align-items: center;

    div {
      font-weight: bold;
    }

    p {
      font-size: 12px;
    }
  }
}
</style>
